import styled from 'styled-components';

import { Colour, Shadow } from '@xemplo/style-constants';
import { zIndex } from '@xemplo/zindex';

export const Container = styled.div`
  background: ${Colour.Light[100]};
  border-radius: 8px;
  ${Shadow.Light1};
  z-index: ${zIndex.Popover};
`;
